export default __webpack_public_path__ + "static/media/autoapprove.75a9b3c0.png";